import { Fragment } from 'react';
import FooterActionsSection from './FooterActionsSection';
import InboxSettingsFooterSection from './InboxSettingsFooterSection';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const NavSidebarFooter = ({
  onCreateCustomViewClick
}) => {
  return /*#__PURE__*/_jsxs(Fragment, {
    children: [/*#__PURE__*/_jsx(FooterActionsSection, {
      onCreateCustomViewClick: onCreateCustomViewClick
    }), /*#__PURE__*/_jsx(InboxSettingsFooterSection, {})]
  });
};
NavSidebarFooter.displayName = 'NavSidebarFooter';
export default NavSidebarFooter;